module.exports = "<!-- <div *ngIf=\"!isMapLoaded\" class=\"loading\">\r\n    Loading\r\n    <span></span>\r\n</div> -->\r\n<router-outlet></router-outlet>\r\n"